import {showroomDeviceTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = showroomDeviceTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const showroomDeviceReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default showroomDeviceReducer;
